export const SAVE_PROJECT_INFO_START = 'SAVE_PROJECT_INFO_START';
export const SAVE_PROJECT_INFO_SUCCESS = 'SAVE_RPOJECT_INFO_SUCCESS';
export const SAVE_PROJECT_INFO_FAILURE = 'SAVE_RPOJECT_INFO_FAILURE';
